import { buildStrand } from "./utils/buildStrand.js";
import { parseGroupNotation } from "./utils/parseGroupNotation.js";
/**
 * Build a molecule from a `chemical-groups` abbreviation.
 *
 * The notation is the one the `mass-tools` packages speak — `HAlaGlyOH`,
 * `MeAlaGlyProPh`, `H(Ala)3OH`, `HODampDcmpH` — where every symbol stands for a
 * structure carrying attachment points, the elements included: `H` is `H-R` and
 * `O` is `R1-O-R2`. Consecutive symbols are condensed by dropping the two
 * attachment points that face each other and bonding the atoms they sat on, and
 * a point nothing is condensed onto leaves its atom the hydrogen it was drawn
 * without. A notation holding several strands separated by a dot gives one
 * molecule with several fragments.
 *
 * A one-letter or database sequence is not understood here: convert it first
 * with `sequenceToMF` from `peptide` or from `nucleotide`, then pass the result.
 * @param ocl - openchemlib, as `import * as OCL from 'openchemlib'`.
 * @param notation - the group notation.
 * @returns the molecule the notation builds.
 */
export function expandChemicalGroups(ocl, notation) {
    const { Molecule } = ocl;
    const trimmed = notation.trim();
    if (trimmed === '')
        throw new Error('the notation is empty');
    const molecule = new Molecule(0, 0);
    for (const part of trimmed.split('.')) {
        if (part.trim() === '')
            throw new Error('the notation has an empty strand');
        molecule.addMolecule(buildStrand(ocl, parseGroupNotation(ocl, part)));
    }
    // Every group brings the coordinates of its own idcode, they would overlap.
    // Inventing new ones redraws the stereo bonds from the parities the group
    // idcodes carry, so the stereocentres survive the new geometry.
    molecule.inventCoordinates();
    return molecule;
}
//# sourceMappingURL=expandChemicalGroups.js.map